import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../baseQueryWithReauth';
import type { UserSettingsResponse, UserSettingsUpdatePayload } from './models';

const USER_SETTINGS_TAG = 'user_settings';

export const userSettingsApi = createApi({
  reducerPath: 'user_settings',
  baseQuery: baseQueryWithReauth,
  tagTypes: [USER_SETTINGS_TAG],
  endpoints: (build) => ({
    getUserSettings: build.query<UserSettingsResponse, void>({
      query: () => ({
        url: '/user/settings',
        headers: { Accept: 'application/json' },
      }),
      providesTags: [{ type: USER_SETTINGS_TAG, id: 'DETAIL' }],
    }),
    updateUserSettings: build.mutation<UserSettingsResponse, UserSettingsUpdatePayload>({
      query: (data) => ({
        url: '/user/settings',
        method: 'PATCH',
        body: data,
        headers: { Accept: 'application/json' },
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(userSettingsApi.util.updateQueryData('getUserSettings', undefined, () => data));
        } catch {
          /* mutation failed — cache stays as is */
        }
      },
    }),
  }),
});

export const { useGetUserSettingsQuery, useUpdateUserSettingsMutation } = userSettingsApi;
